import Utils from 'src/utils';
const actionsToBroadcast = [
    'PUT_USER_RIGHT_SUCCESS',
    'SET_SUPER_RIGHTS',
    'LOAD_EMPLOYEES_SUCCESS',
    'PUT_USER_SUCCESS',
    'DELETE_USER_SUCCESS',
    'POST_USER_SUCCESS',
    'LOAD_USER_INFO_SUCCESS',
    'LOAD_ALL_EMPLOYEES_SUCCESS',
    'LOAD_EMPLOYEES_OPTIONS_SUCCESS',
    'SAVE_EMPLOYEE_CONTRACTS',
    'SAVE_ALL_EMPLOYEES_CONTRACTS',
    'SUCCESS_UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS',
    'SAVE_NEW_EMPLOYEE_CONTRACT',
    'UPDATE_EMPLOYEE_CONTRACT',
    'PUT_DEPARTMENT_SUCCESS',
    'DELETE_DEPARTMENT_SUCCESS',
    'POST_DEPARTMENT_SUCCESS',
    'LOAD_DEPARTMENTS_WITH_JOBS_SUCCESS',
    'LOAD_DEPARTMENTS_OPTIONS_SUCCESS',
    'LOAD_JOBS_SUCCESS',
    'PUT_JOB_SUCCESS',
    'POST_JOB_SUCCESS',
    'DELETE_JOB_SUCCESS',
    'SUBMIT_WORK_SHIFT_SUCCESS',
    'UPDATE_WORK_SHIFT_SUCCESS',
    'DELETE_WORK_SHIFT_SUCCESS',
    'PUT_CONFIGURATION_SUCCESS',
    'PUT_CONFIGURATION_LUNCH_SUCCESS',
    'PUT_CONFIGURATION_BREAK_SUCCESS',
    'PUT_CONFIGURATION_TIME_RATE_SUCCESS',
    'PUT_CONFIGURATION_GENERAL_SUCCESS',
    'PUT_CONFIGURATION_MERIT_SUCCESS',
    'PUT_CONFIGURATION_DIRECTO_SUCCESS',
    'PUT_CONFIGURATION_CONFIRMATION_ACTIONS_SUCCESS',
    'PUT_CONFIGURATION_AXAPTA_SUCCESS',
    'PUT_CONFIGURATION_PERSONA_SUCCESS',
    'UPDATE_PROJECT_SUCCESS',
    'DELETE_PROJECT_SUCCESS',
    'CREATE_PROJECT_SUCCESS',
    'UPDATE_PROJECT_USERS_SUCCESS',
    'UPDATE_PROJECT_JOBS_SUCCESS',
    'DELETE_PROJECT_USERS_SUCCESS',
    'DELETE_PROJECT_JOBS_SUCCESS',
    'SET_LOGGING_OUT'
];
const broadcastActionsMap = Utils.arrays.arrayToKeyMap(actionsToBroadcast);
export default broadcastActionsMap;
